import { configureStore } from '@reduxjs/toolkit';
import { TokenReducer } from './reducers/tokenSlice';

const store = configureStore({
  reducer: {
    token: TokenReducer,
  },
});

export default store;
